import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import buildSearchUrl from './buildSearchUrl';
import buildEventDetailHref from '../../services/buildEventDetailHref';

export default function useWhatSearchNavigation({ onNavigate } = {}) {
    const history = useHistory();

    const goToSuggestedEvent = useCallback((suggestion) => {
        const url = buildEventDetailHref(suggestion && suggestion.slug);
        if (!url) {
            return;
        }
        if (onNavigate) {
            onNavigate();
        }
        history.push(url);
    }, [history, onNavigate]);

    const goToSearchResults = useCallback((searchState) => {
        if (onNavigate) {
            onNavigate();
        }
        history.push(buildSearchUrl(searchState));
    }, [history, onNavigate]);

    return { goToSuggestedEvent, goToSearchResults };
}
